<img #imgContainer
    [src]="renderedImage ? renderedImage : currentImageUrl"
    [alt]="alt"
    [height]="height"
    [width]="width"
    [class]="classes+ ' fx-block'"
    [default]="default"
    [classList]="auxClassList"/>
